export type NextPageParams = {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  deletedItems?: number;
};

export type NextPageResult = {
  nextPage: number;
  offset: number;
  totalPages: number;
  nextTotal: number;
};

export const getNextPageAfterDelete = ({
  currentPage,
  pageSize,
  totalItems,
  deletedItems = 1,
}: NextPageParams): NextPageResult => {
  const safePageSize = Math.max(1, pageSize);
  const safeDeleted = Math.max(0, deletedItems);
  const nextTotal = Math.max(0, totalItems - safeDeleted);
  const totalPages = Math.max(1, Math.ceil(nextTotal / safePageSize));
  const nextPage = Math.min(Math.max(1, currentPage), totalPages);
  const offset = (nextPage - 1) * safePageSize;

  return {
    nextPage,
    offset,
    totalPages,
    nextTotal,
  };
};
